<template>

  <div class="mod pre-rank-buy">
    <div class="mod__hd">
      <img src="../../../../assets/img/base/title-final-games.png" alt="决赛记录" />
    </div>
    <div class="mod_bd">
      <k-table-actions v-if="allActions" :actions="allActions" skin="match" />
    </div>
  </div>
</template>

<script>
  import {
    mapGetters,
    mapActions
  } from 'vuex'
  export default {
    name: 'my-final-games',
    computed: {
      ...mapGetters(['realityCupId', 'nowTime', 'finalRes']),
      ...mapGetters('reality', ['allActions'])
    },
    methods: {
      ...mapActions(['loadRealityCupId']),
      ...mapActions('reality', ['loadGames'])
    },
    async created() {
      if (!this.realityCupId) {
        await this.loadRealityCupId()
      }
      await this.loadGames({
        cupId: this.realityCupId
      })
      // console.log(JSON.stringify(games));
    }
  };

</script>
